// When this file is changed, run `yarn ui:genColors` to regenerate ui/stylesheets/_colors.scss.

/** @deprecated - prefer ui/styles/colors.ts */
const colors = {
  transparent: "transparent",
  // golds
  goldDarkX2: "#4C3F15",
  goldDarkX1: "#73612E",
  goldDark: "#917D43",
  gold: "#B09C61",
  goldLight: "#CCB983",
  goldLightX1: "#E5D4A1",
  goldLightX2: "#F0E1B6",
  goldLightX3: "#F0EAD8",
  goldLightX4: "#F3F0EB",
  goldLightX5: "#FAF9F7",

  // stones
  black: "#000",
  stoneDarkX3: "#222",
  stoneDarkX2: "#2E2E2E",
  stoneDarkX1: "#3D3D3D",
  stoneDark: "#616161",
  stone: "#8A8A8A",
  stoneLight: "#B8B8B8",
  stoneLightX1: "#D6D6D6",
  stoneLightX2: "#E5E5E5",
  stoneLightX3: "#F0F0F0",
  stoneLightX4: "#F5F5F5",
  stoneLightX5: "#FAFAFA",
  white: "#FFFFFF",

  // sapphires
  sapphireDarkX1: "#184f99",
  sapphireDark: "#255da8",
  sapphire: "#336cb8",
  sapphireLight: "#3a80d1",
  sapphireLightX1: "#60adf0",
  sapphireLightX2: "#a0d3fa",
  sapphireLightX3: "#cde8fa",
  sapphireLightX4: "#e6f3fc",
  sapphireLightX5: "#f2faff",

  // sapphires for dark backgrounds
  sapphireNightDarkX3: "#1c2a3d",
  sapphireNightDarkX2: "#2b456b",
  sapphireNightDarkX1: "#1259b8",
  sapphireNightDark: "#2067c7",
  sapphireNight: "#3078d6",
  sapphireNightLight: "#358cf0",
  sapphireNightLightX1: "#57b0ff",

  // amethysts
  amethystDarkX1: "#4F39A8",
  amethystDark: "#5F49B8",
  amethyst: "#715BC7",
  amethystLight: "#8469DB",
  amethystLightX1: "#9E82FA",
  amethystLightX2: "#DCD1FF",
  amethystLightX3: "#ede8ff",

  // room layout highlights (TODO: rename these)
  roomLayoutDark: "#DD3AD5",
  roomLayoutMiddle: "#FFCCFC",
  roomLayoutLight: "#FBE7FA",

  // rubys
  rubyDarkX4: "#2e0a0a",
  rubyDarkX3: "#430f0f",
  rubyDarkX2: "#751a1a",
  rubyDarkX1: "#922",
  rubyDark: "#d63c3c",
  ruby: "#f55d58",
  rubyLight: "#ff8885",
  rubyLightX1: "#fac0be",
  rubyLightX2: "#ffd9d6",
  rubyLightX3: "#fff1f0",

  // emeralds
  emeraldDarkX1: "#218a5c",
  emeraldDark: "#2e9963",
  emerald: "#47b279",
  emeraldLight: "#60d190",
  emeraldLightX1: "#a1e5be",
  emeraldLightX2: "#cef5e1",
  emeraldLightX3: "#e6faf0",
  emeraldLightX4: "#edfcf6",

  // nano greens
  nanoGreen: "#35bd70",
  nanoGreenLight: "#4dd689",
  nanoGreenLightX1: "#60E69B",

  // citrines
  citrineDarkX1: "#d65222",
  citrineDark: "#e56232",
  citrine: "#f57945",
  citrineLight: "#ff8957",
  citrineLightX1: "#ffa375",
  citrineLightX2: "#ffe0cc",
  citrineLightX3: "#ffebe0",

  // ambers
  amberDarkX4: "#39280f",
  amberDarkX3: "#5d4218",
  amberDarkX2: "#825b21",
  amberDarkX1: "#b27e2e",
  amberDark: "#d69f40",
  amber: "#f0c051",
  amberLight: "#fad264",
  amberLightX1: "#ffdf75",
  amberLightX2: "#ffea94",
  amberLightX3: "#fff3c2",
  amberLightX4: "#fff9e0",
} as const;

export function getThemeColor(color?: ColorLabel, fallback?: ColorLabel): ColorValue | undefined {
  if (color && colors[color]) {
    return colors[color];
  }

  if (fallback && colors[fallback]) {
    return colors[fallback];
  }

  return undefined;
}

export type ColorLabel = keyof typeof colors;
export type ColorValue = (typeof colors)[ColorLabel];

export default colors;
